import { accessTokenProjectsSelector } from './auth-selectors';
import { RootState } from '@algoan/dashboard/store/store';
import { createSelector } from '@reduxjs/toolkit';

export const skipOnboardingSelector = (state: RootState): boolean => state.preferences.skipOnboarding ?? false;

export const favoriteProjectSelector = (state: RootState): string | undefined => state.preferences.favoriteProject;

export const defaultProjectSelector: (state: RootState) => { projectId: string; projectName: string } | undefined =
  createSelector(
    accessTokenProjectsSelector,
    favoriteProjectSelector,
    (
      accessTokenProjects: { [key: string]: string },
      favoriteProject: string | undefined,
    ): { projectId: string; projectName: string } | undefined => {
      if (favoriteProject) {
        return { projectId: favoriteProject, projectName: accessTokenProjects[favoriteProject] };
      } else {
        const entries = Object.entries(accessTokenProjects).sort((entry1, entry2) => {
          const projectName1 = entry1[1];
          const projectName2 = entry2[1];
          return projectName1.localeCompare(projectName2);
        });
        const firstEntry: [string, string] | undefined = entries[0];

        return firstEntry ? { projectId: firstEntry[0], projectName: firstEntry[1] } : undefined;
      }
    },
  );
